import { toast } from "react-toastify";
import { HRMS_EMPLOYEE_API_URL } from "../../../../Constants/baseConstant";
import axiosInstance from "../../../../../axiosInstance";
import { getDomain, getEmployeeId } from "../../../Base/helper/baseFunctions";
import NProgress from 'nprogress';

export const GetNoticePeriodHelper = async (params) => {
    NProgress.start();
    return await axiosInstance(`/ecms/getNoticePeriod`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
        }
    })
        .then(res => {
            NProgress.done();
            return { message: "Retrive successfully", hasError: false, data: res?.data }
        }).catch(err => {
            NProgress.done();
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const UpdateNoticePeriodHelper = async (params) => {
    toast.info("Updating...")
    return await axiosInstance(`/ecms/updateNoticePeriod`, {
        method: "PUT",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_empid: getEmployeeId(),
            notice_period: params?.notice_period
        }
    })
        .then(res => {
            toast.dismiss();
            toast.success("Notice period updated successfully");
            return { message: "Notice period updated successfully", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message);
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}